import React from 'react'

const VideoBackgroundProfile = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="159.721" height="159.721" viewBox="0 0 159.721 159.721">
            <g id="Group_71430" data-name="Group 71430" transform="translate(-39 -141.621)">
                <g id="Group_71429" data-name="Group 71429" transform="translate(39 141.621)">
                    <circle id="Ellipse_1054" data-name="Ellipse 1054" cx="79.861" cy="79.861" r="79.861" fill="rgba(0,0,0,0.8)" />
                    <g id="person_outline_black_24dp_2_" data-name="person_outline_black_24dp (2)" transform="translate(21.05 21.051)" opacity="0.43">
                        <path id="Path_27497" data-name="Path 27497" d="M0,0H117.62V117.62H0Z" fill="none" />
                        <path id="Path_27498" data-name="Path 27498" d="M43.174,13.3A10.283,10.283,0,1,1,32.891,23.587,10.282,10.282,0,0,1,43.174,13.3m0,44.071c14.543,0,29.87,7.149,29.87,10.283v5.386H13.3V67.658c0-3.134,15.327-10.283,29.87-10.283M43.174,4A19.587,19.587,0,1,0,62.762,23.587,19.582,19.582,0,0,0,43.174,4Zm0,44.071C30.1,48.071,4,54.633,4,67.658v14.69H82.349V67.658C82.349,54.633,56.249,48.071,43.174,48.071Z" transform="translate(15.636 15.636)" fill="#fff" />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default VideoBackgroundProfile
